export default "/static/vaccine/record.png"